export const PARTICIPANT_BREAKDOWN = 0;
export const ORDER_BREAKDOWN = 1;
